<div class="align-center g-space-sm full-container p-space-md bdp-l bdp-r color-border-primary">
  <cam-font-icon name="infos" type="xs"></cam-font-icon>
  <cam-expandable-text>
    <div class="fs-font-body-md-default-size">
      {{ this._item?.description }}
    </div>
  </cam-expandable-text>
</div>
